import React from 'react';
import PropTypes from 'prop-types';

import Box from '@quintoandar/cozy-core/Box';
import Checkbox from '@quintoandar/cozy-core/Checkbox';
import FeedbackBlock from '@quintoandar/cozy-core/FeedbackBlock';
import CalendarEmpty from '@quintoandar/cozy-icons/CalendarEmpty';

import PageWrapper from 'components/PageWrapper';
import RetryFeedback from 'components/RetryFeedback';

import messages from './messages';

export const ErrorState = ({ title, onRetry }) => (
  <PageWrapper>
    <RetryFeedback title={title} onRetry={onRetry} />
  </PageWrapper>
);

ErrorState.propTypes = {
  title: PropTypes.object.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export const EmptySchedulesState = ({
  onBack,
  showKeepSessionOption,
  keepSession,
  onChangeKeepSession,
}) => (
  <PageWrapper>
    {showKeepSessionOption && (
      <Box mt={2}>
        <Checkbox
          name="keepSession"
          label={messages.keepSessionLabel}
          checked={keepSession}
          onChange={onChangeKeepSession}
        />
      </Box>
    )}
    <Box mt={4}>
      <FeedbackBlock
        kind="empty-state"
        icon={CalendarEmpty}
        title={messages.schedulesDatesEmptyTitle}
        subtitle={messages.schedulesDatesEmptySubtitle}
        buttonLabel={messages.backButtonLabel}
        buttonClick={onBack}
      />
    </Box>
  </PageWrapper>
);

EmptySchedulesState.propTypes = {
  onBack: PropTypes.func.isRequired,
  showKeepSessionOption: PropTypes.bool,
  keepSession: PropTypes.bool,
  onChangeKeepSession: PropTypes.func,
};
